module.exports = __webpack_public_path__ + "img/Diferential_calculus.6c3cdef3.svg";